export const getTagFromEnv = (env: string): string => {
    switch (env.toLowerCase()) {
        case 'qa': {
            return 'dev';
        }
        case 'next': {
            return 'next';
        }
        case 'prod': {
            return 'prod';
        }
        default: {
            return 'dev';
        }
    }
};
